module.exports = __webpack_public_path__ + "static/media/calendar2.9073818b.png";